export const DEFAULT_TAB_ROUTE = "referrals";

export const COPY_CONFIRMATION_DURATION_MS = 1_600;

export const TAB_ROUTES = {
  referrals: "referrals",
  leaderboard: "leaderboard",
  resources: "resources",
  tiers: "tiers",
  faqs: "faqs",
  payouts: "payouts",
} as const;

export type ReferralTabRoute = keyof typeof TAB_ROUTES;

export const REFERRAL_TABS = [
  { id: "referrals", translationKey: "tabs.referrals" },
  { id: "resources", translationKey: "tabs.resources" },
  { id: "tiers", translationKey: "tabs.tiers" },
  { id: "faqs", translationKey: "tabs.faqs" },
  { id: "payouts", translationKey: "tabs.payouts" },
  { id: "leaderboard", translationKey: "tabs.leaderboard" },
] as const satisfies ReadonlyArray<{
  id: ReferralTabRoute;
  translationKey: string;
}>;

export const isReferralTabRoute = (value: string | null): value is ReferralTabRoute =>
  Boolean(value && value in TAB_ROUTES);

export const normalizeReferralTabRoute = (value?: string): ReferralTabRoute => {
  const candidate = value ?? null;
  return isReferralTabRoute(candidate) ? candidate : DEFAULT_TAB_ROUTE;
};

export const tierData = [
  {
    id: "tier_1",
    unlockAt: 1,
    progressTarget: 5,
    bonus: "3%",
    commission: "0.5%",
  },
  {
    id: "tier_2",
    unlockAt: 6,
    progressTarget: 6,
    bonus: "5%",
    commission: "0.5%",
  },
] as const;

export const REFERRAL_INVITE_URLS = {
  arthaHome: "https://artha.link/",
  quoteImage: "https://artha.link/wp-content/uploads/2026/01/qoute.webp",
  decorativeStar: "https://artha.link/wp-content/uploads/2026/01/star-shap.svg",
  playButton: "https://artha.link/wp-content/uploads/2026/03/Play-button.svg",
} as const;

type ReferralInviteTestimonial = {
  id: "hardikGami" | "akshataNBhatt";
  profileLink: string;
  thumbnailUrl: string;
  videoUrl?: string;
  paragraphKeys: readonly string[];
};

export const REFERRAL_INVITE_TESTIMONIALS: readonly ReferralInviteTestimonial[] = [
  {
    id: "hardikGami",
    profileLink: "https://artha.link/@hardik-gami",
    thumbnailUrl: "https://artha.link/wp-content/uploads/2026/04/Hardik-thumbnail.webp",
    paragraphKeys: ["paragraph1", "paragraph2", "paragraph3", "paragraph4"] as const,
  },
  {
    id: "akshataNBhatt",
    profileLink: "https://artha.link/@akshata-n-bhatt",
    thumbnailUrl: "https://artha.link/wp-content/uploads/2026/03/Artha-akshata.webp",
    videoUrl: "https://www.youtube.com/embed/p0v2zV_GEsM?autoplay=1",
    paragraphKeys: ["paragraph1", "paragraph2", "paragraph3"] as const,
  },
] as const;
